export interface ApiFailure { status: number; mutation: boolean }

let failure: ApiFailure | null = null;
const listeners = new Set<() => void>();

// Only presentation state. Never retain URLs, credentials, response bodies or form data.
export const apiErrors = {
    getSnapshot: () => failure,
    subscribe(listener: () => void) {
        listeners.add(listener);
        return () => { listeners.delete(listener); };
    },
    report(status: number, method: string) {
        if (!Number.isInteger(status) || (status !== 404 && (status < 500 || status > 599))) return;
        const mutation = !['GET', 'HEAD', 'QUERY'].includes(method.toUpperCase());
        // Do not hide a possibly failed save behind a later background read failure.
        if (failure?.mutation && !mutation) return;
        failure = { status, mutation };
        listeners.forEach(listener => listener());
    },
    dismiss() {
        failure = null;
        listeners.forEach(listener => listener());
    },
};
